import React, { useState } from 'react';
import PageTableLayout from '../components/PageTableLayout';

const breadcrumb = (
  <span>
    Home &nbsp;/&nbsp; Webber &nbsp;/&nbsp; <span className="text-gray-700">Menus</span>
  </span>
);

const columns = [
  { key: 'name', title: 'Menu Name' },
  { key: 'type', title: 'Type' },
  { key: 'status', title: 'Status' },
];

const mockData = [
  { id: 1, name: 'Main Menu', type: 'Header', status: 'Active' },
  { id: 2, name: 'Footer Menu', type: 'Footer', status: 'Active' },
];

const Menus = () => {
  const [data, setData] = useState(mockData);
  const filters = [
    <input key="name" className="border px-2 py-1 rounded text-sm" placeholder="Enter menu name" />,
    <select key="type" className="border px-2 py-1 rounded text-sm">
      <option>Select Type</option>
      <option>Header</option>
      <option>Footer</option>
    </select>,
    <button key="filter" className="bg-blue-600 text-white px-3 py-1 rounded text-xs">Filter</button>
  ];
  const handleEdit = (row) => alert(`Edit: ${row.name}`);
  const handleAddNew = () => alert('Add New Menu');
  return (
    <PageTableLayout
      title="Menus"
      breadcrumb={breadcrumb}
      columns={columns}
      data={data}
      filters={filters}
      onEdit={handleEdit}
      onAddNew={handleAddNew}
    />
  );
};

export default Menus;
